"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bech32Address = void 0;
const bech32_1 = __importDefault(require("bech32"));
class Bech32Address {
    constructor(address) {
        this.address = address;
    }
    static shortenAddress(bech32, maxCharacters) {
        if (maxCharacters >= bech32.length) {
            return bech32;
        }
        const i = bech32.indexOf("1");
        const prefix = bech32.slice(0, i);
        const address = bech32.slice(i + 1);
        maxCharacters -= prefix.length;
        maxCharacters -= 3; // For "..."
        maxCharacters -= 1; // For "1"
        if (maxCharacters <= 0) {
            return "";
        }
        const mid = Math.floor(address.length / 2);
        let former = address.slice(0, mid);
        let latter = address.slice(mid);
        while (maxCharacters < former.length + latter.length) {
            if ((former.length + latter.length) % 2 === 1 && former.length > 0) {
                former = former.slice(0, former.length - 1);
            }
            else {
                latter = latter.slice(1);
            }
        }
        return prefix + "1" + former + "..." + latter;
    }
    static validate(bech32Address, prefix) {
        const { prefix: decodedPrefix } = bech32_1.default.decode(bech32Address);
        if (prefix && prefix !== decodedPrefix) {
            throw new Error(`Unexpected prefix (expected: ${prefix}, actual: ${decodedPrefix})`);
        }
    }
    static defaultBech32Config(mainPrefix, validatorPrefix = "val", consensusPrefix = "cons", publicPrefix = "pub", operatorPrefix = "oper") {
        return {
            bech32PrefixAccAddr: mainPrefix,
            bech32PrefixAccPub: mainPrefix + publicPrefix,
            bech32PrefixValAddr: mainPrefix + validatorPrefix + operatorPrefix,
            bech32PrefixValPub: mainPrefix + validatorPrefix + operatorPrefix + publicPrefix,
            bech32PrefixConsAddr: mainPrefix + validatorPrefix + consensusPrefix,
            bech32PrefixConsPub: mainPrefix + validatorPrefix + consensusPrefix + publicPrefix,
        };
    }
    toBech32(prefix) {
        const words = bech32_1.default.toWords(this.address);
        return bech32_1.default.encode(prefix, words);
    }
}
exports.Bech32Address = Bech32Address;
//# sourceMappingURL=index.js.map